import store from '../../state/store';

export const roleGuard = (to, from, next) => {

  store.commit('permissions/setCurrentPermission', to.meta.module)

  next();
};
